import React, { useEffect, useRef } from "react";
import "./Shell.scss";
import { Outlet, useLocation } from "react-router-dom";
import { HeaderV3 } from "../../components";
import {
  AGENT_HOME,
  ARTIST_STORIES,
  BID,
  WHY,
} from "../../routes/constants";
import { get } from "lodash";
import { FooterV3, FooterV3Snap } from "../../sections";
import AnnouncementBanner from "../AnnouncementBanner/AnnouncementBanner";

const NO_NAVBAR = [AGENT_HOME];
const NO_FOOTER = [];
const NO_ANNOUNCE = [BID, ARTIST_STORIES, WHY];
const NO_SNAP = [BID, ARTIST_STORIES, WHY];

function Shell(props) {

  const location = useLocation();
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const handleScroll = () => {
      const nav = document.getElementById("bBAnnouncementBanner");
      const header = document.getElementById("bBNavHeader");
      var height = 0;
      if (nav) {
        height = nav.offsetHeight - 1;
      } else {
        height = 0;
      }
      if (container.scrollTop > height) {
        header.style.setProperty('padding-top', `0px`);
        header.style.setProperty('position', `fixed`);
        if (nav) {
          nav.style.setProperty('z-index', '1999')
        }
      } else {
        header.style.setProperty('padding-top', `${height}px`);
        header.style.setProperty('position', `absolute`);
        if (nav) {
          nav.style.setProperty('z-index', '2001')
        }
      }
    };
    container.addEventListener('scroll', handleScroll);
    if (container) {
      containerRef.current.scrollTo(0, 0);
    }
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [location]);

  const renderAnnouncement = () => {
    if (NO_ANNOUNCE.includes(props.currentLocation)) {
      return null;
    } else {
      return <AnnouncementBanner/>
    }
  };

  const renderNavbar = () => {
    if (props.noNavbar || NO_NAVBAR.includes(props.currentLocation)) {
      return <></>;
    } else {
      return (
        <HeaderV3
          home={get(props, "home")}
          currentLocation={get(props, "currentLocation")}
        />
      );
    }
  };

  const renderFooter = () => {
    if (NO_FOOTER.includes(props.currentLocation)) {
      return null;
    } else if (NO_SNAP.includes(props.currentLocation)) {
      return <FooterV3 />;
    } else {
      return <FooterV3Snap />;
    }
  };

  return (
    <div id="snap" ref={containerRef} className={`shell ${NO_SNAP.includes(props.currentLocation) ? "" : "snap" }`}>
      {renderAnnouncement()}
      {renderNavbar()}
      <Outlet />
      {renderFooter()}
    </div>
  );
}

export default Shell;
